export enum StatusValue {
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
  EMPTY = '',
  GOOD = 'good',
  AVERAGE = 'average',
  TRUE = 'true',
  FALSE = 'false',
  NO_DATA = 'no_data',
  LESS_THAN_5 = '<5',
  FIVE_TO_TEN = '5-10',
  GREATER_THAN_10 = '>10',
  N_A = 'N/A',
  SUCCESSFUL = 'successful',
  REJECTED = 'rejected',
  SCHEDULED = 'scheduled',
  NO_THRESHOLD = 'no_threshold'
}

export enum TagColor {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  DEFAULT = 'default'
}

export enum StatusTypeEnum {
  BATTERY = 'battery',
  SIGNAL = 'signal',
  PHEROMONE = 'pheromone',
  TWEAKS = 'tweaks',
  SELF_CLEANING = 'self-cleaning',
  SEVEN_DAY_TOTAL = '7_day_total'
}

export type Status = StatusValue | string | null | undefined;
